<script setup>
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useRouter } from 'vue-router'
import B2CHeader from 'components/home/B2CHeader'
import { useMeta } from 'quasar'
import { useGA } from '#/useGA'
import B2CExplanation from 'components/home/B2CExplanation'
import B2CBenefits from 'components/home/B2CBenefits'
import B2CStats from 'components/home/B2CStats'
import B2CPartners from 'components/home/B2CPartners'
import B2CContactPopup from 'components/home/B2CContactPopup'
import B2CReferences from 'components/home/B2CReferences.vue'
import B2CTestimonials from 'components/home/B2CTestimonials.vue'
import { ref } from 'vue'

const { isProduction, globalConfiguration } = useGlobalStore()
const { event } = useGA()
const router = useRouter()
if (globalConfiguration.value && globalConfiguration.value.pages && globalConfiguration.value.pages.b2cHome) {
  useMeta({
    title: globalConfiguration.value.pages.b2cHome.title,
    meta: {
      description: { name: 'description', content: globalConfiguration.value.pages.b2cHome.description },
      keywords: { name: 'keywords', content: globalConfiguration.value.pages.b2cHome.keyword },
      canonical: { rel: 'canonical', href: 'https://raumpioniere.ch' },
      'og:title': { property: 'og:title', content: globalConfiguration.value.pages.b2cHome.ogTitle ? globalConfiguration.value.pages.b2cHome.ogTitle : globalConfiguration.value.pages.b2cHome.title },
      'og:image': { property: 'og:image', content: globalConfiguration.value.pages.b2cHome.ogImage ? globalConfiguration.value.pages.b2cHome.ogImage : 'https://raumpioniere.ch/icons/favicon-128x128.png' },
      'og:url': { property: 'og:url', content: 'https://raumpioniere.ch' },
      'og:description': { property: 'og:description', content: globalConfiguration.value.pages.b2cHome.ogDescription ? globalConfiguration.value.pages.b2cHome.ogDescription : globalConfiguration.value.pages.b2cHome.description },
      'og:type': { property: 'og:type', content: globalConfiguration.value.pages.b2cHome.ogType ? globalConfiguration.value.pages.b2cHome.ogType : 'B2C Landing Page' },
      'og:locale': { property: 'og:locale', content: 'de_CH' }
    }
  })
}

async function openAnalyzer () {
  await router.push('/b2c/analyzer')
  event('navigation', {
    eventCategory: 'button',
    eventLabel: 'b2c features - Jetzt Analyse starten'
  })
}
const contactVisible = ref(false)
</script>

<template lang="pug">
.b2c--container
  b2-c-contact-popup(v-model:visible="contactVisible" :always="true")
  b2-c-header
  b2-c-explanation(@openAnalyzer="openAnalyzer")
  b2-c-testimonials
  b2-c-benefits(@openAnalyzer="openAnalyzer")
  b2-c-stats(@openAnalyzer="openAnalyzer")
  b2-c-references
  b2-c-partners
</template>

<style lang="sass">
.b2c--container
  overflow: hidden
  .blogsContainer
    @media screen and (max-width: 1023px)
      padding: 0px !important
  .blogs--carousel-wrapper
    @media screen and (max-width: 1023px)
      padding: 0px !important
  .blog--img-wrapper
    @media screen and (max-width: 1023px)
      max-width: 346px !important
.b2c--exclusive-desktop
  margin-top: 114px
  font-weight: 700
  font-size: 40px
  line-height: 130%
  text-align: center
  color: #22223C
  padding: 0 130px
  margin-bottom: 24px
.b2c--exclusive-mobile
  font-weight: 700
  font-size: 20px
  line-height: 130%
  padding: 80px 0 40px 0
  text-align: center
</style>
